import { render, staticRenderFns } from "./IconSearch.vue?vue&type=template&id=605c9a5a&scoped=true"
import script from "./IconSearch.vue?vue&type=script&lang=js"
export * from "./IconSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c9a5a",
  null
  
)

export default component.exports